import { useQuery, QueryResult } from '@apollo/client';

import { getPriceConfig } from './__generated__/getPriceConfig';
import getPriceConfigQuery from './priceConfig.graphql';

export const usePriceConfig = (): QueryResult<getPriceConfig> => {
  return useQuery<getPriceConfig>(getPriceConfigQuery);
};
